module.exports = __webpack_public_path__ + "static/media/mads_danish.64b24cf3.mp3";